<div
  class="d-lg-none"
  [class]="content().retentionStickyView ? 'd-none' : ''"
></div>

@if (offer(); as offer) {
  @if (variant() === 'card') {
    <div
      class="card rounded card__retention-view"
      [style.z-index]="isCollapsed ? 'auto' : '11'"
    >
      <div class="card--body d-flex flex-column">
        <essent-order-overview-header
          [offer]="offer"
          [monthlyAmountLabel]="{
            value: content().monthlyAmountLabel,
          }"
          [monthlyAmountTooltip]="content().monthlyAmountTooltip"
          [budgetBillLabel]="{
            value: content().budgetBillSuggestion,
          }"
          [budgetBillTooltip]="content().budgetBillSuggestionTooltip"
          [showEditButton]="content().showEditButton"
          [fluidContainer]="content().retentionStickyView"
          [showCostsInHeader]="content().showCostsInHeader"
          [enableNewOfferCardTitles]="content().enableNewOfferCardTitles"
          [costsWithDiscountLabel]="content().costsWithDiscountLabel"
        >
        </essent-order-overview-header>
        <ng-container
          *ngTemplateOutlet="body; context: { offer, variant: variant() }"
        ></ng-container>
      </div>
    </div>

    @if (crossSellProductSelected() || crossSellLoyaltySelected()) {
      <div
        class="card card__cross-sell rounded my-2 card__retention-view d-none d-lg-block"
        [style.z-index]="isCollapsed ? 'auto' : '11'"
      >
        <div class="card__cross-sell__header rounded-top">
          <h5 class="h5 mb-0">{{ content().crossSellTitle }}</h5>
        </div>
        <div class="card__cross-sell__body rounded-bottom">
          @if (crossSellLoyaltySelected()) {
            <div
              class="d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap mb-1"
            >
              <p>{{ content().crossSellThuisvoordeelTitle }}</p>
              <p class="strong">{{ content().crossSellThuisvoordeelCost }}</p>
            </div>
          }
          @if (crossSellProductSelected()) {
            <div
              class="d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap mb-1"
            >
              <p>
                {{ fulfillmentCrossSellProduct()?.content?.longTitle }}
                {{ content().monthlySuffix }}
              </p>
              <p class="strong">
                {{
                  fulfillmentCrossSellProduct()?.price | euroCurrency: '1.0-2'
                }}
              </p>
            </div>
          }
        </div>
      </div>
    }
  } @else if (variant() === 'accordion') {
    <div ngbAccordion class="accordion">
      <div
        ngbAccordionItem
        [collapsed]="deviceInfo().isMobile"
        class="accordion-item--brand-header"
      >
        <div ngbAccordionHeader class="accordion-header">
          <button ngbAccordionButton class="accordion-button align-items-start">
            <div class="d-flex flex-column gap-2 w-100">
              <p class="h3" wlCSCapture>
                @if (content().enableNewOfferCardTitles) {
                  {{ offer?.productTitle }} - {{ offer?.durationTitle }}
                } @else {
                  {{ offer?.productTitle }}
                }
              </p>

              <div class="costs-in-header">
                <span
                  *scText="{
                    value: content().monthlyAmountLabel,
                  }"
                ></span>
                <span class="h3">{{
                  offer?.expectedMonthlyAmount
                    ? (offer.expectedMonthlyAmount.toString() | roundedCurrency)
                    : ''
                }}</span>
              </div>
            </div>
          </button>
        </div>

        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-container
              *ngTemplateOutlet="body; context: { offer, variant: variant() }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>

    @if (smartChargingAddonSelected()) {
      <div
        class="card card__cross-sell rounded my-2 card__smart-charging"
        [style.z-index]="isCollapsed ? 'auto' : '11'"
      >
        <div class="card__cross-sell__header rounded-top">
          <h5 class="h5 mb-0">{{ content().smartChargingTitle }}</h5>
        </div>
        <div class="card__cross-sell__body rounded-bottom">
          <p class="strong fst-italic mb-1">
            {{ content().smartChargingPropositionValue }}
          </p>
          <p *wlGenericRichText="{ value: content().smartChargingContent }"></p>
        </div>
      </div>
    }
  }
} @else {
  <wl-svg-skeleton-loader [mask]="skeletonLoaderMask()" />
}

<ng-template #body let-offer="offer" let-variant="variant">
  <div
    #collapse="ngbCollapse"
    [(ngbCollapse)]="isCollapsed"
    class="d-lg-block flex-grow-1"
    [class.px-2]="variant === 'card'"
  >
    <p
      class="fw-bold"
      [class.mt-2]="variant === 'card'"
      *scText="{
        value: content().summaryCalculationBasedOn,
      }"
      wlCSCapture
    ></p>
    <div class="mb-2">
      @if (consumptionValuesVM(); as consumptionValuesVM) {
        <wl-order-overview-consumption
          [consumptionValues]="consumptionValuesVM"
        ></wl-order-overview-consumption>
      }
    </div>
    <div class="mb-2">
      <wl-order-overview-cost
        [label]="{ value: content().electricityLabel }"
        [cost]="electricityOverview()?.totalPrice?.expectedYearlyAmount"
      ></wl-order-overview-cost>
      @if (gasOverview()?.totalPrice?.expectedYearlyAmount) {
        <wl-order-overview-cost
          [label]="{ value: content().gasLabel }"
          [cost]="gasOverview()?.totalPrice?.expectedYearlyAmount"
        ></wl-order-overview-cost>
      }
    </div>
    @if (variant === 'card') {
      <wl-order-overview-budget-bill
        [beforeDiscountYearlyLabel]="{
          value: content().beforeDiscountExpectedYearlyLabel,
        }"
        [beforeDiscountYearlyAmount]="offer.beforeDiscountExpectedYearlyAmount"
        [cashbackAmount]="offer.discountPrice"
        [cashbackLabel]="{ value: content().incentiveLabel }"
        [yearlyLabel]="yearlyCostLabel()"
        [yearlyAmount]="offer.expectedYearlyAmount"
        [monthlyAmount]="offer.expectedMonthlyAmount"
        [monthlyAmountLabel]="{
          value: content().monthlyAmountLabel,
        }"
        [monthlyAmountAdditionalLabel]="content().monthlyAmountAdditionalLabel"
        [monthlyAmountTooltip]="content().monthlyAmountTooltip"
        [budgetBillAmount]="offer.budgetBillAmount"
        [budgetBillLabel]="{
          value: content().budgetBillSuggestion,
        }"
        [budgetBillTooltip]="content().budgetBillSuggestionTooltip"
        [showCostsInHeader]="content().showCostsInHeader"
        [hideAnnualCosts]="content().hideAnnualCosts"
        [costsWithDiscountLabel]="content().costsWithDiscountLabel"
        [termijnbedragVariantA]="!!termijnbedragVariantA()"
        [termijnbedragVariantB]="!!termijnbedragVariantB()"
        [enableRemoveBBA]="content().enableRemoveBBA"
        [promoCode]="promoCodeBadge()"
      ></wl-order-overview-budget-bill>
    } @else if (variant === 'accordion') {
      @if (offer.discountPrice) {
        <div class="d-flex justify-content-between mb-1">
          <span wlCSCapture>{{
            content().beforeDiscountExpectedYearlyLabel
          }}</span>
          <span wlCSCapture>
            {{ offer.beforeDiscountExpectedYearlyAmount | roundedCurrency }}
          </span>
        </div>

        <div class="d-flex justify-content-between text-success mb-1">
          <span wlCSCapture> {{ content().incentiveLabel }}</span>
          <span wlCSCapture class="flex-shrink-0">
            -&nbsp;{{ offer.discountPrice | roundedCurrency }}
          </span>
        </div>
      }

      <div class="d-flex justify-content-between fw-bold mb-1">
        <span wlCSCapture>{{ yearlyCostLabel() }}</span>
        <span wlCSCapture>
          {{ offer.expectedYearlyAmount | roundedCurrency }}
        </span>
      </div>
    }

    <div class="mb-2"></div>

    @if (displayMGM()) {
      <div class="rounded-3 text-center card__mgm-badge mb-2">
        {{
          content().mgmSharedValueText
            | interpolate
              : {
                  variables: {
                    mgmValue: mgmSharedValue() | roundedCurrency,
                  },
                }
        }}
      </div>
    }
    @if (hasGiftcard()) {
      <div class="rounded-3 text-center card__giftcard-badge mb-2">
        {{ offer.incentiveTitle }}
      </div>
    }
    <hr />
    <div class="d-flex mb-3 mt-3 justify-content-center">
      <button
        class="p-0 btn btn-link text-primary"
        [wlTrackLink]="content().AOMModalLinkText"
        [trackLinkInfo]="{
          rendering: {
            componentName: 'product detail',
          },
          field: content().AOMModalLinkText,
          eventType: 'link-click',
          type: 'button',
        }"
        wlAutomationId="show-tariffs"
        (click)="showTariffs.emit(offer)"
        *scText="{
          value: content().enableRemoveBBA
            ? content().AOMModalLinkTextNoBBA
            : content().AOMModalLinkText,
        }"
        wlCSCapture
      ></button>
      @if (content().AOMmodalTooltip) {
        <span class="d-flex align-items-center ps-1">
          <wl-tooltip
            [tooltip]="{
              description: content().AOMmodalTooltip,
            }"
          ></wl-tooltip>
        </span>
      }
    </div>
    @if (variant === 'card' && usps().length) {
      <div class="card__usps">
        @if (usps(); as usps) {
          <wl-offer-usps [usps]="usps"></wl-offer-usps>
        }
      </div>
    }
  </div>

  @if (crossSellProductSelected() || crossSellLoyaltySelected()) {
    <div class="d-lg-none">
      @if (isCollapsed) {
        @if (crossSellLoyaltySelected()) {
          <div
            class="p-2 pb-0 d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap cross-sell-mobile-header"
            [ngClass]="crossSellProductSelected() ? 'pb-0' : 'pb-3'"
          >
            <p>
              {{ content().crossSellThuisvoordeelTitle }}
            </p>
            <p>
              {{ content().crossSellThuisvoordeelCost }}
            </p>
          </div>
        }
        @if (crossSellProductSelected()) {
          <div
            class="p-2 pb-3 d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap cross-sell-mobile-header"
          >
            <p>
              {{ fulfillmentCrossSellProduct()?.content?.longTitle }}
              {{ content().monthlySuffix }}
            </p>
            <p>
              +&nbsp;{{
                fulfillmentCrossSellProduct()?.price | euroCurrency: '1.0-2'
              }}
            </p>
          </div>
        }
      } @else {
        <div class="cross-sell-mobile-header">
          <h5 class="h5 mb-0">{{ content().crossSellTitle }}</h5>
        </div>
        <div class="p-2 pb-3">
          @if (crossSellLoyaltySelected()) {
            <div
              class="d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap mb-1"
            >
              <p>
                {{ content().crossSellThuisvoordeelTitle }}
              </p>
              <p class="strong">
                {{ content().crossSellThuisvoordeelCost }}
              </p>
            </div>
          }
          @if (crossSellProductSelected()) {
            <div
              class="d-flex flex-row gap-2 align-middle justify-content-between flex-nowrap mb-1"
            >
              <p>
                {{ fulfillmentCrossSellProduct()?.content?.longTitle }}
                {{ content().monthlySuffix }}
              </p>
              <p class="strong">
                +&nbsp;{{
                  fulfillmentCrossSellProduct()?.price | euroCurrency: '1.0-2'
                }}
              </p>
            </div>
            <p
              *wlGenericRichText="
                fulfillmentCrossSellProduct()?.content?.longSubtitle
              "
            ></p>
          }
        </div>
      }
    </div>
  }

  <div class="flex-grow-1"></div>

  @if (variant === 'card') {
    <div ngbDropdown class="d-flex justify-content-center dropdown d-lg-none">
      <button
        class="btn btn-outline-primary dropdown__button shadow-sm d-flex justify-content-center align-items-center"
        id="dropdownBasic1"
        (click)="toggleCollapse()"
      >
        <crnt-icon
          class="dropdown__icon d-flex"
          [icon]="isCollapsed ? 'angle-down' : 'angle-up'"
        ></crnt-icon>
      </button>
    </div>
  }
</ng-template>

<div
  class="fade d-lg-none"
  [class.show]="!isCollapsed"
  [class]="content().retentionStickyView ? 'd-none' : ''"
></div>

@if (content().orderFootnote) {
  <wl-rich-text-wrapper
    [field]="{ value: content().orderFootnote }"
    class="d-block mt-3"
  >
    <div class="vertical-list"></div>
  </wl-rich-text-wrapper>
}
